import GlobalReduxStore from 'stores/globalReduxStore';
import {SignalREvent, SignalRHub} from '../constants/dataEnum';
import {invokeAPI} from '../stores/business/commonBusiness';

// eslint-disable-next-line import/prefer-default-export
export const getCurrentProgressAutoA1OffsetCalibration = async () => {
  let response;
  const {dispatch} = GlobalReduxStore.getStore();
  try {
    response = await dispatch(
      invokeAPI(SignalRHub.INSTRUMENT, SignalREvent.GET_CURRENT_PROGRESS_AUTO_A1_OFFSET_CALIBRATION),
    );
  } catch (error) {
    console.error('error in getCurrentProgressAutoA1OffsetCalibration', error);
  }
  return response;
};
